module.exports = __webpack_public_path__ + "static/img/directions.a4b92b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/directions.png
// module id = 5Z0z
// module chunks = 1